import _ from 'underscore';

export function lambdaConvertForArrayTypes(logic, secondLogic, operator, name, type) {
  return (values) => {
    const fieldId = 'd:d';
    let url = '';

    _.each(values, (value, index) => {
      if (index > 0) {
        url += ` ${logic}  `;
      }
      url += `${name}/${secondLogic}(${fieldId} ${operator} Enum.${type}'${value}')`;
    });
    return url;
  };
}
